// 「오픈채팅 입장」 메뉴 노출 훅 — src/lib/openchatEntry.js 의 React 포장 (2026-10-29)
//
//   const openchatVisible = useOpenchatVisible();
//   · 서버 openchat_room_visible() — 2026-11-01 0시(KST)부터 · 어드민은 미리보기로 늘 참. 읽는 중·실패는 false(숨김).
import { useEffect, useState } from "react";
import { fetchOpenchatVisible, getOpenchatVisibleCache } from "../lib/openchatEntry";

export default function useOpenchatVisible() {
  const [visible, setVisible] = useState(() => getOpenchatVisibleCache() === true);
  useEffect(() => {
    let alive = true;
    fetchOpenchatVisible().then((v) => { if (alive) setVisible(v); });
    return () => { alive = false; };
  }, []);
  return visible;
}
